<template>
  <nav class="side-menu">
    <ul class="side-menu-list">
      <li class="side-menu-list__item" v-for="route in routes" :key="route.name">
        <AsideMenuButton
          :route="route"
          :subitems="route.subitems"
          :active-group="activeGroup"
          @change-active-group="handleChangeActiveGroup"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
import AsideMenuButton from '../aside-menu-button';

export default {
  props: {
    routes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeGroup: '',
    };
  },
  components: { AsideMenuButton },
  methods: {
    handleChangeActiveGroup(activeGroup) {
      if (this.activeGroup !== activeGroup) {
        this.activeGroup = activeGroup;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.side-menu-list__item {
  &:nth-child(n+2) {
    margin-top: 8px;
  }
}
</style>
